import { DropdownMenu } from '@octopus-do/octopus-storybook'
import {
  FileTextLight,
  MessageLines,
  OctopusBlueLogo,
  QuestionCircle,
  Layer as ShortcutIcon,
  SlackLogo,
  XLogo,
  YoutubeLogo,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useAuth } from '@/hooks'

export const ProjectInfoMenuContent: React.FC = () => {
  const { authenticated } = useAuth()

  return (
    <>
      <DropdownMenu.Button id="about" title="About" icon={OctopusBlueLogo} />
      <DropdownMenu.Divider />
      <DropdownMenu.Button
        id="shortcuts"
        title="Shortcuts"
        icon={ShortcutIcon}
      />
      <DropdownMenu.A
        href="https://help.octopus.do"
        title="Help center"
        icon={QuestionCircle}
      />
      {authenticated && (
        <DropdownMenu.Button
          id="feedback"
          title="Leave feedback"
          icon={MessageLines}
        />
      )}
      <DropdownMenu.A
        href="https://octopus.do/sitemap/changelog/"
        title="Changelog"
        icon={FileTextLight}
      />
      <DropdownMenu.Divider />
      <DropdownMenu.Link
        to="/join-slack"
        title="Slack community"
        icon={SlackLogo}
      />
      <DropdownMenu.A
        href="https://www.youtube.com/watch?v=2YVqprhGMh4&list=PLNNXHvRPIctj4fUHr7Y8oh-j3ZNhfIB_8"
        title="Video tutorial"
        icon={YoutubeLogo}
      />
      <DropdownMenu.A
        href="https://x.com/octopusdoHQ"
        title="Updates on X"
        icon={XLogo}
      />
    </>
  )
}
